import React, { useEffect, useState } from 'react';
import './ReferralPage.css';

const ReferralPage = ({ username, setClickCount, triggerToast }) => {
  const [refs, setRefs] = useState(0);
  const [rewards, setRewards] = useState([]);

  useEffect(() => {
    const fetchUserRefs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users/refs/${username}`);
        if (!response.ok) throw new Error('Failed to fetch refs');
        const data = await response.json();
        setRefs(data.refs); 
      } catch (err) {
        console.error(err);
      }
    };

    const fetchRewards = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/referrals`);
        if (!response.ok) throw new Error('Failed to fetch rewards');
        const data = await response.json();
        setRewards(data); 
      } catch (err) {
        console.error(err);
      }
    };

    fetchUserRefs();
    fetchRewards();
  }, [username]);

const claimReward = async (rewardId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/referrals/claim`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ reward_id: rewardId }),
        });

        const data = await response.json();
        if (response.ok) {
            setClickCount(Number(data.clickCount));
            setRewards((current) => current.map((reward) => (
              reward.id === rewardId ? { ...reward, claimed: true } : reward
            )));
            triggerToast('Реферальная награда получена!');
        } else {
            triggerToast(data.message || 'Не удалось получить награду');
        }
    } catch (error) {
        console.error('Error claiming reward:', error);
    }
};


  return (
    <div className="referral-container">
      <div className="referral-header">
        <h1 className="referral-title">Реферальные награды</h1>
        <div className="chest-image">
          <img src="/krest.png" alt="Chest" />
        </div>
      </div>

      <div className="progress-container">
        <div className="slider">
          <div className="slider-fill" style={{ width: `${Math.min(refs, 100) / 100 * 100}%` }}></div>
        </div>
        <div className="milestones">
          <div className="milestone">5</div>
          <div className="milestone">10</div>
          <div className="milestone">20</div>
          <div className="milestone">50</div>
          <div className="milestone">100</div>
        </div>
      </div>

      <div className="rewards-list">
        {rewards.map((reward) => (
          <div className="reward-item" key={reward.id}>
            <img src="монетка.png" alt="Reward" className="reward-image" />
            <p className="reward-description">Пригласи {reward.required_refs} друзей — награда {reward.reward} кликов</p>
            <button
              className="reward-button"
              onClick={() => claimReward(reward.id)}
              disabled={reward.claimed || refs < reward.required_refs}
            >
              {reward.claimed ? 'Получено' : refs >= reward.required_refs ? 'Получить награду' : `Требуется ${reward.required_refs}`}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralPage;
